import { render, staticRenderFns } from "./VerifiedWagestream.vue?vue&type=template&id=c70cc4a2&"
import script from "./VerifiedWagestream.vue?vue&type=script&setup=true&lang=js&"
export * from "./VerifiedWagestream.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports